<template>
  <div class="toolbar-view">
    <md-button
      v-for="action in actions"
      v-if="action.visible !== false"
      class="action"
      :class="{'separator-after': action.separatorAfter, 'md-primary': action.highlight}"
      :key="action.action"
      @click.native="onAction(action)"
    >
      <md-icon class="md-size-2x">
        {{ action.icon }}
        <md-tooltip>{{ action.title }}</md-tooltip>
      </md-icon>
    </md-button>
  </div>
</template>

<script>
export default {
  methods: {
    onAction (action) {
      this.$emit(action.action)
    }
  },
  props: {
    highlightSave: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    actions () {
      return [
        {
          action: 'open',
          visible: false,
          icon: 'move_to_inbox',
          title: 'Открыть'
        },
        {
          action: 'save',
          icon: 'save',
          highlight: this.highlightSave,
          title: 'Сохранить'
        },
        {
          action: 'export',
          icon: 'move_to_inbox',
          title: 'Экспорт в Word',
          separatorAfter: true
        },
        {
          action: 'undo',
          icon: 'undo',
          title: 'Отмена'
        },
        {
          action: 'redo',
          icon: 'redo',
          title: 'Повторить',
          separatorAfter: true
        },
        {
          action: 'copy',
          icon: 'content_copy',
          title: 'Копировать'
        },
        {
          action: 'cut',
          icon: 'content_cut',
          title: 'Вырезать'
        },
        {
          action: 'paste',
          icon: 'content_paste',
          title: 'Вставить',
          separatorAfter: true
        },
        {
          action: 'header',
          visible: true,
          icon: 'format_size',
          title: 'Заговок раздела'
        },
        {
          action: 'list',
          icon: 'format_list_bulleted',
          title: 'Маркированный список'
        },
        {
          action: 'add-source',
          icon: 'link',
          title: 'Ссылка на источник'
        },
        {
          action: 'add-image',
          visible: false,
          icon: 'insert_photo',
          title: 'Вставка рисунка'
        },
        {
          action: 'add-table',
          visible: false,
          icon: 'view_comfy',
          title: 'Вставка таблицы'
        },
        {
          action: 'add-formula',
          visible: false,
          icon: 'functions',
          title: 'Вставка выражения'
        },
        {
          action: 'add-listing',
          visible: false,
          icon: 'code',
          title: 'Вставка листинга'
        }
      ]
    }
  }
}
</script>

<style lang="sass">
.toolbar-view
  text-align: left
  margin-left: 15px
  height: 60px
  .action
    cursor: pointer
    &.separator-after
      margin-right: 30px
    // &.highlight
    //  color: $accent
</style>


// WEBPACK FOOTER //
// ToolbarView.vue?1b95c682